<template>
  <v-popover v-bind="$attrs"
             v-on="$listeners"
             popover-class="v-popover"
             popover-base-class="v-popover"
             popover-arrow-class="v-popover__arrow"
             :popover-inner-class="popoverInnerClass">
    <slot></slot>
    <slot name="popover" slot="popover"></slot>
  </v-popover>
</template>
<script>
export default {
  computed: {
    popoverInnerClass() {
      return this.$attrs["popover-inner-class"] || 'v-popover__inner'
    }
  }
}
</script>
<style lang="scss">
.v-popover {
  display: block !important;
  z-index: 10000;

  &[x-placement^="top"] {
    margin-bottom: 7px;
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;
  }

  &[x-placement^="right"] {
    margin-left: 5px;
  }

  &[x-placement^="left"] {
    margin-right: 5px;
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }

  &__inner, &__inner-no-transform {
    border-radius: 5px;
    border: 1px solid var(--border-color);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    background: var(--background);

  }
  &__inner {
    transform: translateX(-90px);
  }
}
</style>
